<template>
  <div class="div-resultado-full" v-bind:id="id">
    <Resumo
      class="no-print"
      :mostraCamposCenario="mostraCamposCenario"
      :dadosForm="dadosFormResumo"
    />
    <div>
      <!-- IMPOSTOS REFATORADOS -->

      <PreferenciaTarifaria
        v-show="tributoAtivo == 'preferencia_tarifaria'"
        :class="[imprimeSelecionado('PREFERENCIA_TARIFARIA')]"
        :exibeImposto="exibeImposto('PREFERENCIA_TARIFARIA')"
        :id="id"
        :tributoAtivo="tributoAtivo"
        :buscarImposto="buscarImposto"
        :dadosForm="dadosForm"
        @loading="loading => (this.loading = loading)"
      />

      <Exportacao
        v-show="tributoAtivo == 'exportacao'"
        :class="[imprimeSelecionado('IMPOSTO_EXPORTACAO')]"
        :exibeImposto="exibeImposto('IMPOSTO_EXPORTACAO')"
        :id="id"
        :tributoAtivo="tributoAtivo"
        :buscarImposto="buscarImposto"
        :dadosForm="dadosForm"
        @loading="loading => (this.loading = loading)"
      />

      <Importacao
        v-show="tributoAtivo == 'class_importacao'"
        :class="[imprimeSelecionado('IMPOSTO_IMPORTACAO')]"
        :exibeImposto="exibeImposto('IMPOSTO_IMPORTACAO')"
        :id="id"
        :tributoAtivo="tributoAtivo"
        :buscarImposto="buscarImposto"
        :dadosForm="dadosForm"
        @loading="loading => (this.loading = loading)"
      />

      <DefesaComercial
        v-show="tributoAtivo == 'defesa_comercial'"
        :class="[imprimeSelecionado('DEFESA_COMERCIAL')]"
        :exibeImposto="exibeImposto('DEFESA_COMERCIAL')"
        :id="id"
        :tributoAtivo="tributoAtivo"
        :buscarImposto="buscarImposto"
        :dadosForm="dadosForm"
        @loading="loading => (this.loading = loading)"
      />

      <Ipi
        v-show="tributoAtivo == 'ipi'"
        :class="[imprimeSelecionado('IPI')]"
        @limparImpostos="resetarImpostos($event)"
        :id="id"
        :buscarImposto="buscarImposto"
        :dadosForm="dadosForm"
        :tributoAtivo="tributoAtivo"
        @loading="loading => (this.loading = loading)"
      />

      <PisCofins
        v-show="tributoAtivo == 'pis_cofins'"
        :class="[imprimeSelecionado('PIS_COFINS')]"
        :exibeImposto="exibeImposto('PIS_COFINS')"
        :id="id"
        :tributoAtivo="tributoAtivo"
        :dadosForm="dadosForm"
        :buscarImposto="buscarImposto"
        :limparImpostos="limparImpostos"
        @loading="loading => (this.loading = loading)"
      />

      <CideCombustivel
        v-show="tributoAtivo == 'cide_combustivel'"
        :class="[imprimeSelecionado('CIDE_COMBUSTIVEL')]"
        :exibeImposto="exibeImposto('CIDE_COMBUSTIVEL')"
        :id="id"
        :tributoAtivo="tributoAtivo"
        :dadosForm="dadosForm"
        :buscarImposto="buscarImposto"
        :limparImpostos="limparImpostos"
        @loading="loading => (this.loading = loading)"
      />

      <IcmsInterno
        v-show="tributoAtivo == 'icms_interno'"
        :bssnSelecionado="bssnSelecionado"
        :class="[imprimeSelecionado('ICMS')]"
        :exibeImposto="exibeImposto('ICMS')"
        :id="id"
        :tributoAtivo="tributoAtivo"
        :dadosForm="dadosForm"
        :buscarImposto="buscarImposto"
        :limparImpostos="limparImpostos"
        @loading="loading => (this.loading = loading)"
      />

      <IcmsSt
        v-show="tributoAtivo == 'icms_st'"
        :class="[imprimeSelecionado('ICMS_ST')]"
        :exibeImposto="exibeImposto('ICMS_ST')"
        :id="id"
        :tributoAtivo="tributoAtivo"
        :dadosForm="dadosForm"
        :buscarImposto="buscarImposto"
        :limparImpostos="limparImpostos"
        @loading="loading => (this.loading = loading)"
      />

      <IcmsCargaLiquida
        v-show="tributoAtivo == 'carga_liquida'"
        :class="[imprimeSelecionado('ICMS_CARGA_LIQUIDA')]"
        :exibeImposto="exibeImposto('ICMS_CARGA_LIQUIDA')"
        :id="id"
        :tributoAtivo="tributoAtivo"
        :dadosForm="dadosForm"
        :buscarImposto="buscarImposto"
        :limparImpostos="limparImpostos"
        @loading="loading => (this.loading = loading)"
      />

      <IcmsAntecipacao
        v-show="tributoAtivo == 'antecipacao'"
        :class="[imprimeSelecionado('ICMS_ANTECIPACAO_TRIBUTARIA')]"
        :exibeImposto="exibeImposto('ICMS_ANTECIPACAO_TRIBUTARIA')"
        :id="id"
        :tributoAtivo="tributoAtivo"
        :dadosForm="dadosForm"
        :buscarImposto="buscarImposto"
        :limparImpostos="limparImpostos"
        @loading="loading => (this.loading = loading)"
      />

      <IcmsDifal
        v-show="tributoAtivo == 'difal'"
        :class="[imprimeSelecionado('ICMS_DIFERENCIAL_DE_ALIQUOTAS')]"
        :exibeImposto="exibeImposto('ICMS_DIFERENCIAL_DE_ALIQUOTAS')"
        :id="id"
        :tributoAtivo="tributoAtivo"
        :dadosForm="dadosForm"
        :buscarImposto="buscarImposto"
        :limparImpostos="limparImpostos"
        @loading="loading => (this.loading = loading)"
      />
    </div>
    
    <FooterImpressao />
  </div>
</template>

<script>
//IMPOSTOS
import Exportacao from "@/modules/Tributos/Exportacao/Exportacao.vue";
import Ipi from "@/modules/Tributos/Ipi/Ipi.vue";
import IcmsInterno from "@/modules/Tributos/IcmsInterno/IcmsInterno.vue";
import IcmsAntecipacao from "@/modules/Tributos/IcmsAntecipacao/IcmsAntecipacao.vue";
import IcmsCargaLiquida from "@/modules/Tributos/IcmsCargaLiquida/IcmsCargaLiquida.vue";
import IcmsDifal from "@/modules/Tributos/IcmsDifal/IcmsDifal.vue";
import IcmsSt from "@/modules/Tributos/IcmsSt/IcmsSt.vue";
import Importacao from "@/modules/Tributos/Importacao/Importacao.vue";
import CideCombustivel from "@/modules/Tributos/CideCombustivel/CideCombustivel.vue";
import DefesaComercial from "@/modules/Tributos/DefesaComercial/DefesaComercial.vue";
import PisCofins from "@/modules/Tributos/PisCofins/PisCofins.vue";
import PreferenciaTarifaria from "@/modules/Tributos/PreferenciaTarifaria/PreferenciaTarifaria.vue";
import Resumo from "@/components/Resumo/Resumo.vue";
// FIM IMPOSTOS

import FooterImpressao from "@/components/FooterImpressao/FooterImpressao.vue";
import { mapGetters } from "vuex";

export default {
  props: [
    "id",
    "dadosForm",
    "buscarImposto",
    "tributoAtivo",
    "mostraCamposCenario",
    "dataCenario",
    "impostoSelecionadoImpressao",
    "bssnSelecionado"
  ],
  components: {
    CideCombustivel,
    DefesaComercial,
    Exportacao,
    Ipi,
    IcmsInterno,
    IcmsAntecipacao,
    IcmsCargaLiquida,
    IcmsDifal,
    IcmsSt,
    Importacao,
    PisCofins,
    PreferenciaTarifaria,
    Resumo,
    FooterImpressao
},
  data() {
    return {
      abas: [],
      limparImpostos: false,
      loading: false,
      selecionado: {}
    };
  },
  provide() {
    return {
      alteracaoImportacao: this.dadosForm.tipoOperacao == "41"
    };
  },
  mounted() {
    // console.log(this.dadosForm);
  },
  watch: {
    loading() {
      this.$emit("loadingResultado", this.loading, this.id);
    }
  },
  computed: {
    ...mapGetters("resultado", ["getPossiveisAbas", "getPossiveisAbasCenario"]),
    dadosFormResumo() {
      let data = this.dataCenario.find(p => p.id == this.id);
      return { ...data, ...this.dadosForm };
    }
  },
  methods: {
    resetarImpostos: function(boolean) {
      this.limparImpostos = boolean;
    },
    exibeImposto(imposto) {
      let existe = this.getPossiveisAbasCenario(this.id)
        ? this.getPossiveisAbasCenario(this.id).includes(imposto)
        : null;
      return existe ? true : false;
    },
    imprimeSelecionado(imposto) {
      return this.impostoSelecionadoImpressao.includes(imposto) ? "impressao" : "no-print";
    }
  }
};
</script>

<style lang="scss">
.alerta-space {
  font-weight: bold;
  margin-bottom: 10px;
  font-size: 13px !important;

  .titulo {
    font-size: 13px;
  }
}

.alerta-space .alerta-color {
  color: red;
  font-weight: bold;
  font-size: 13px !important;
}

.text-bold {
  font-weight: bold !important;
}

.no-border {
  border: 0 !important;
}

.ml10 {
  margin-left: 10px;
}

.mb5 {
  margin-bottom: 5px;
}

.pt5 {
  padding-top: 5px;
}

.flex-between {
  display: flex;
  justify-content: space-between;
}

.color-subtitle-aplic {
  color: #207a23 !important;
}

.base-legal-similar {
  float: right;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-end;
}

.btn {
  &__calendar {
    background: #969896 !important;
    color: var(--branco) !important;
    border: 0;
    padding: 5px 38px 5px 12px;
    font-family: "Roboto Condensed";
    text-transform: uppercase;
    border-radius: 2px;
    position: relative;
    cursor: pointer;
    -webkit-transition: all 0.3s ease;
    transition: all 0.3s ease;
    span {
      background-color: #484848;
      position: absolute;
      right: 0;
      top: 0;
      content: "";
      height: 100%;
      width: 30px;
      transition: all 0.3s ease;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    &:hover {
      background-color: #3d3d3d !important;
      color: var(--branco) !important;
      text-decoration: underline !important;
    }
  }
}
.div-resultado-full {
  border-radius: 10px;
  // box-shadow: 2px 2px 14px #00000010;
}
@media only print {
  .impressao {
    display: block !important;
  }
}
</style>
